import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useApiClient } from "../useApiClient";

import { SAVED_DASHBOARDS_QUERY_KEY } from "./useSavedDashboards";

export function useDeleteSavedDashboard() {
  const client = useApiClient();
  const queryClient = useQueryClient();
  return useMutation<void, Error, string>({
    mutationFn: async (saved_dashboard_id) => {
      const { error } = await client.DELETE(
        "/api/saved-dashboards/{saved_dashboard_id}",
        { params: { path: { saved_dashboard_id } } },
      );
      if (error !== undefined) {
        throw new Error("Failed to delete saved dashboard");
      }
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: SAVED_DASHBOARDS_QUERY_KEY });
    },
  });
}
